<template>
  <div>
    <md-progress-bar v-if="loading" md-mode="indeterminate"></md-progress-bar>

    <md-content class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card class="md-card-example">
          <md-card-header>
            <div>Поиск:</div>
          </md-card-header>
          <md-card-content>
            <form novalidate @submit.prevent="getTasks">
              <md-field md-clearable :class="getValidationClass('orderNumber')">
                <label>Скорее пиши номер заказа!</label>
                <md-input v-model="form.orderNumber"></md-input>
                <span class="md-helper-text">Номер заказа</span>
                <div v-if="restErrors.orderNumber.length" class="md-error">
                  <span
                    v-for="(error, index) in restErrors.orderNumber[0].message"
                    :key="index"
                  >
                    {{ error }}
                  </span>
                </div>
              </md-field>
            </form>
          </md-card-content>
        </md-card>
      </div>
    </md-content>

    <md-empty-state
      v-if="!tasks.length"
      md-icon="devices_other"
      md-label="Нет задач на замену"
      md-description="Вы не отправляли запросы на замену."
    ></md-empty-state>

    <md-content v-if="tasks.length" class="md-layout">
      <div
        v-for="task in tasks"
        :key="task.task_id"
        class="md-layout-item md-size-100"
      >
        <md-card class="md-card-example">
          <md-card-area md-inset>
            <md-card-header>
              <h5 class="md-title">Заказ: {{ task.order.order_number }}</h5>
              <div v-if="task.actions.length" class="md-subhead">
                <md-icon>accessible</md-icon>
                <span>
                  Менеджер {{ getUserProfileName(task.actions[0].author_id) }}
                  <span
                    style="vertical-align: unset; cursor: pointer"
                    v-on:click="showLogs = !showLogs"
                  >
                    что-то
                  </span>
                  делал {{ task.actions[0].created_at | formatDate }}, a начал
                  {{
                    task.actions[task.actions.length - 1].created_at
                      | formatDate
                  }}
                </span>
              </div>
              <div>
                <div v-if="task.status === 'completed'" class="md-subhead">
                  <md-icon>check_circle</md-icon>
                  <span>Готово</span>
                </div>
                <div v-if="task.status === 'new'" class="md-subhead">
                  <md-icon>access_time</md-icon>
                  <span>В очереди на обработку</span>
                </div>
                <div v-if="task.status === 'started'" class="md-subhead">
                  <md-icon>build</md-icon>
                  <span>В процессе работы</span>
                </div>
                <div v-if="task.status === 'deferred'" class="md-subhead">
                  <md-icon>timelapse</md-icon>
                  <span>Отложена</span>
                </div>
              </div>
            </md-card-header>

            <div class="replacement-mobile-card">
              <h6 class="md-title replacement-title">Замены в задаче</h6>
              <md-card
                class="custom-card"
                v-for="replacement in task.replacements"
                :key="replacement.id"
              >
                <md-card-header class="custom-header">
                  <md-card-media
                    class="custom-media"
                    v-if="replacement.thumbnail"
                  >
                    <img
                      height="80"
                      :src="replacement.thumbnail"
                      :alt="replacement.id"
                    />
                  </md-card-media>
                  <div>
                    <div class="md-title">
                      {{ replacement.article_from }} -
                      {{ replacement.size_from }}
                      <md-icon>arrow_right_alt</md-icon>
                      {{ replacement.article_to }} - {{ replacement.size_to }}
                    </div>
                    <div v-if="replacement.is_confirm" class="md-subhead">
                      <md-icon>check_circle</md-icon>
                      <span>Подтвержена</span>
                    </div>
                    <div v-if="!replacement.is_confirm" class="md-subhead">
                      <md-icon>build</md-icon>
                      <span>Не подтвержена</span>
                    </div>
                  </div>
                </md-card-header>

                <md-card-content
                  class="custom-comment"
                  v-if="!!replacement.comment"
                >
                  {{ replacement.comment }}
                </md-card-content>
              </md-card>
            </div>

            <md-card-content class="replacement-content">
              <md-table md-card>
                <md-table-toolbar>
                  <h1 class="md-title">Замены в задаче</h1>
                </md-table-toolbar>

                <md-table-row>
                  <md-table-head>Заменяем</md-table-head>
                  <md-table-head>Предлагаем</md-table-head>
                  <md-table-head>Фото замены</md-table-head>
                  <md-table-head>Комментарий</md-table-head>
                  <md-table-head>Подтверждена</md-table-head>
                </md-table-row>

                <md-table-row
                  v-for="replacement in task.replacements"
                  :key="replacement.id"
                >
                  <md-table-cell>
                    {{ replacement.article_from }} - {{ replacement.size_from }}
                  </md-table-cell>
                  <md-table-cell>
                    {{ replacement.article_to }} - {{ replacement.size_to }}
                  </md-table-cell>
                  <md-table-cell>
                    <img
                      v-if="replacement.thumbnail"
                      width="100"
                      :src="replacement.thumbnail"
                      :alt="replacement.id"
                    />
                    <span v-else>нет</span>
                  </md-table-cell>
                  <md-table-cell>{{ replacement.comment }}</md-table-cell>
                  <md-table-cell>
                    <div v-if="replacement.is_confirm" class="md-subhead">
                      <md-icon>check_circle</md-icon>
                      <span>Подтвержена</span>
                    </div>
                    <div v-if="!replacement.is_confirm" class="md-subhead">
                      <md-icon>build</md-icon>
                      <span>Не подтвержена</span>
                    </div>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card-area>

          <div v-if="task.actions.length && showLogs">
            <md-card-content>
              <md-table md-card>
                <md-table-toolbar>
                  <h1 class="md-title">История действий по задаче</h1>
                </md-table-toolbar>

                <md-table-row>
                  <md-table-head>Дейсвие</md-table-head>
                  <md-table-head>Менеджер</md-table-head>
                  <md-table-head>Дата</md-table-head>
                </md-table-row>

                <md-table-row v-for="action in task.actions" :key="action.id">
                  <md-table-cell>{{ action.action_class }}</md-table-cell>
                  <md-table-cell>
                    {{ getUserProfileName(action.author_id) }}
                  </md-table-cell>
                  <md-table-cell>{{ action.created_at }}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </div>

          <md-card-actions>
            <md-button class="md-primary" v-on:click.prevent="reloadTask(task)">
              Обновить
            </md-button>
            <md-button
              v-if="task.status === 'wait_complete'"
              class="md-accent"
              v-on:click.prevent="actualizeTask(task)"
            >
              Усилить работу менеджера
            </md-button>
          </md-card-actions>
        </md-card>
      </div>
    </md-content>
  </div>
</template>

<script>
  export default {
    name: "Replacements",
    data: () => ({
      form: {
        orderNumber: null,
        offset: 0,
      },
      restErrors: {
        orderNumber: [],
      },
      tasks: [],
      user_profiles: [],
      showLogs: false,
      loading: false,
    }),
    mounted() {
      this.getTasks();
    },
    watch: {
      "form.orderNumber": function () {
        this.getTasks();
      },
    },
    computed: {
      profiles() {
        return this.$store.state.profiles.items;
      },
    },
    methods: {
      getValidationClass(fieldName) {
        if (this.restErrors[fieldName].length) {
          return {
            "md-invalid": true,
          };
        }
      },
      getUserProfileName(managerId) {
        const profile = this.profiles.find(
          (profile) => profile.manager_id === managerId
        );
        return profile ? profile.manager_name : managerId;
      },
      reloadTask(task) {
        this.loading = true;
        this.$axios
          .get("/replacement_reload/" + task.task_id)
          .then((response) => {
            const taskIndex = this.tasks.findIndex(
              (task) => task.task_id === response.data.task_id
            );
            this.$set(this.tasks, taskIndex, response.data);
            this.$store.commit("messages/setMessage", {
              type: "success",
              code: "О да!",
              message: "Данные о задаче обновлены",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      },
      getTasks() {
        this.loading = true;
        this.$axios
          .post("/replacement_my", this.form)
          .then((response) => {
            this.tasks = response.data;
            this.restErrors.orderNumber = [];
          })
          .catch((error) => {
            this.restErrors.orderNumber = error.response.data.filter(
              (err) => err.field === "orderNumber"
            );
          })
          .finally(() => {
            this.loading = false;
          });
      },
      actualizeTask(task) {
        this.loading = true;
        this.$axios
          .get("/replacement_actualize/" + task.task_id)
          .then(() => {
            this.$store.commit("setMessage", {
              type: "success",
              code: "О да!",
              message:
                "Запрос на усиление работы менеджера отправлен, скоро он зашевелится",
            });

            setTimeout(() => {
              this.reloadTask(task);
            }, 500);
          })
          .finally(() => {
            this.loading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .md-card-header .custom-media {
    overflow: hidden;
    margin-left: 0;
    img {
      width: auto;
      height: 80px;
    }
  }

  .replacement-mobile-card {
    display: none;
    @media (max-width: 779px) {
      display: block;
    }
  }

  .replacement-content {
    @media (max-width: 779px) {
      display: none;
    }
  }

  .custom-card {
    box-shadow: none;
    border-top: 1px solid
      var(--md-theme-default-light-divider, rgba(0, 0, 0, 0.12));
    &:last-of-type {
      border-bottom: 1px solid
        var(--md-theme-default-light-divider, rgba(0, 0, 0, 0.12));
    }
  }

  .replacement-title {
    padding: 8px 16px;
  }

  .custom-comment:last-of-type {
    padding-bottom: 12px;
  }

  .custom-header {
    display: flex;
    padding: 8px;
  }
  .md-card .md-title {
    font-size: 18px;
    line-height: 1.2em;
    font-weight: 600;
    @media (max-width: 800px) {
      font-size: 14px;
    }
  }

  .md-card {
    margin: 4px;
    vertical-align: top;
  }

  .md-card-example {
    .md-subhead {
      .md-icon {
        $size: 16px;

        width: $size;
        min-width: $size;
        height: $size;
        font-size: $size !important;
      }

      span {
        vertical-align: middle;
      }
    }

    .card-reservation {
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .md-icon {
        margin: 8px;
      }
    }

    .md-button-group {
      display: flex;

      .md-button {
        min-width: 60px;
        border-radius: 2px;
      }
    }
  }
</style>
